import { render, staticRenderFns } from "./ChatUserList.vue?vue&type=template&id=388a5b72&scoped=true"
import script from "./ChatUserList.vue?vue&type=script&lang=ts"
export * from "./ChatUserList.vue?vue&type=script&lang=ts"
import style0 from "./ChatUserList.vue?vue&type=style&index=0&id=388a5b72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a5b72",
  null
  
)

export default component.exports